import { useEffect } from 'react';

import { Form, Input, Modal } from 'antd';

import { useEditOktaEmail } from 'hooks/user-profile/useEditOktaEmail';

import { useDispatch } from 'react-redux';
import * as userActions from '@redux/user/actions';

const OktaSsoModal = ({ visible, offModal, userProfile }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const editOktaEmail = useEditOktaEmail();

  useEffect(() => {
    if (userProfile && visible) {
      form.setFieldsValue({ oktaEmail: userProfile?.oktaEmail });
    }
  }, [userProfile, visible, form]);

  const handleCancel = () => {
    offModal();
  };

  const handleSave = () => {
    form.validateFields().then((values) => {
      const params = {
        userId: userProfile?.id,
        ...values,
      };

      editOktaEmail.mutateAsync(params).then(() => {
        dispatch(userActions.getUserProfile());
        offModal();
      });
    });
  };

  return (
    <Modal
      bodyStyle={{ paddingBottom: 0 }}
      title={'Change Okta email'}
      visible={visible}
      onOk={handleSave}
      onCancel={handleCancel}
      destroyOnClose={true}
      maskClosable={false}
      okText={'Change Okta email'}
    >
      <Form form={form} labelCol={{ xs: 8 }} wrapperCol={{ xs: 16 }}>
        <Form.Item
          label='Okta email'
          name='oktaEmail'
          rules={[
            {
              required: true,
              message: 'Okta email is required',
            },
            { type: 'email', message: 'Invalid email' },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default OktaSsoModal;
